/** Остались id корневых оверлеев и aria; контент HUD — из React store. */
export const LEG_KICK_DOM = {
  root: 'leg-kick-ui',
  pauseRoot: 'leg-kick-pause',
  pauseTitle: 'leg-kick-pause-title',
  gameOverRoot: 'leg-kick-gameover',
  restartBtn: 'leg-kick-restart-btn',
} as const;
